<template>
  <div>
    <div class="ban-p">
      <img
        v-if="result && result.headerImg"
        :src="imageUrl + result.headerImg"
      />
    </div>
    <div class="g-snva1">
      <div class="wp">
        <subnav :type="5"></subnav>
      </div>
    </div>
    <div class="c"></div>
    <router-view></router-view>
  </div>
</template>

<script>
import subnav from '@/components/subnav';
export default {
  components: {
    subnav
  },
  data () {
    return {

      result:{},
      pageInfo: {
        zhId: '1436536431257817089',
        enId: '1436536402140958722'
      }
    }
  },
  /* mounted () {
    let lang = localStorage.getItem("locale") || 'zh';
    this.lang = lang;
    this.$i18n.locale = lang;
  }, */
  created () {
    let that = this;
    /* if (that.$i18n.locale === 'zh') {
      that.getReport(that.pageInfo.zhId);
    } else if (that.$i18n.locale === 'en') {
      that.getReport(that.pageInfo.enId);
    } */
    that.getReport(that.pageInfo.enId);
  },
  /* watch: {
    '$i18n.locale' (newValue) {
      if (this.$i18n.locale === 'zh') {
        this.getReport(this.pageInfo.zhId);
      } else if (this.$i18n.locale === 'en') {
        this.getReport(this.pageInfo.enId);
      }
    }
  }, */
  methods: {
   

    // 获取行业报告信息
    getReport (id) {
      let that = this;
      let data = {
        id: id
      };
      that.$http
        .getReport(data)
        .then((res) => {
          if (res.code == 200) {
            let result = res.result;
            that.result = result;
          }
        })
    },

  }
}
</script>

<style>
</style>